import React from "react";
import { styled } from "@mui/material/styles";

import { StorageStatus } from "../../../util/enums";

interface StyledStorageBadgeProps {
  backgroundColor: string;
  textColor: string;
}

const StyledStorageBadge = styled("div", {
  shouldForwardProp: (prop) => prop !== "backgroundColor" && prop !== "textColor",
})<StyledStorageBadgeProps>(({ backgroundColor, textColor }) => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "16px",
  background: backgroundColor,
  color: textColor,
  padding: "8px 12px",
  borderRadius: "100px",
  display: "inline-block",
}));

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  className?: string;
};

const BadgeStorageStatus = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value) {
      return (
        <StyledStorageBadge
          data-cy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          className={className}
        >
          {value}
        </StyledStorageBadge>
      );
    }

    return <></>;
  };

  switch (value?.toLowerCase()) {
    case StorageStatus.LOADED.toLowerCase():
      return renderBadge("#ECFDF3", "#039855", value);
    case StorageStatus.EMPTY.toLowerCase():
      return renderBadge("#F9FAFB", "#475467", value);
    case StorageStatus.FULL.toLowerCase():
      return renderBadge("#D1FADF", "#32D583", value);
    default:
      return renderBadge("#ECFDF3", "#039855", value);
  }
};

export default BadgeStorageStatus;
